import { ThemeConfig } from 'antd';

import palette from '../default/palette';

const layout = {
  colorBgLayout: palette.gray[11],
  borderRadius: 4
} as ThemeConfig['token'];

const colors = {
  colorPrimary: palette.brand.primary,
  colorBgBase: palette.gray[10],
  colorInfoBg: palette.alpha(palette.gray[0], 0.03),
  colorIcon: palette.gray[0],
  controlItemBgActive: palette.alpha(palette.gray[0], 0.25),
  colorTextBase: palette.gray[0],
  colorText: palette.alpha(palette.gray[0], 0.85),
  colorTextPlaceholder: palette.alpha(palette.gray[0], 0.25),
  colorTextHeading: palette.gray[0],
  colorTextSecondary: palette.alpha(palette.gray[0], 0.65),
  colorTextTertiary: palette.alpha(palette.gray[0], 0.45),
  colorTextQuaternary: palette.alpha(palette.gray[0], 0.25)
} as ThemeConfig['token'];

const error = {
  colorErrorText: palette.red[2],
  colorErrorBorder: palette.alpha(palette.red[5], 0.2),
  colorErrorBg: palette.alpha(palette.gray[12], 0.08)
} as ThemeConfig['token'];

const tokens = {
  ...layout,
  ...colors,
  ...error
} as ThemeConfig['token'];

export default tokens;
